



const dataAbout = [

    {
        id: 1,
        title : 'HIGH QUAILITY',
        text : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
    },
    {
        id: 2,
        title : 'biG cOLLECTION',
        text : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
    },
    {
        id: 3,
        title : 'TOP RESOURCE',
        text : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
    },
    {
        id: 4,
        title : 'BIG COMMUNITY',
        text : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
    },
    

]

export default dataAbout;